import { request } from './utils';

export default class AccountService {
    static async logout() {
      // P4 clears the auth cookies (jwt + readable session cookies) on DELETE.
      const response = await request('/api/session', {
        method: 'DELETE'
      });

      return response; /** @important response should be raw, not response.data, as we need to be able to read the status code. */
    }

    static async refreshToken() {
      // P4 rotates the jwt cookie + expiresIn/remainingTime on refresh.
      const response = await request('/api/session/refresh', {
        method: 'POST'
      });

      return response;
    }
}
